<crm-single-select
  #singleSelectComponent
  [options]="companies"
  [(selectedItem)]="selectedCompany"
  (selectedItemChange)="selectedCompanyChange.emit($event)"
  [virtualScroll]="true"
  [virtualScrollItemSize]="33"
  [showClear]="showClear"
  [loading]="loading"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [appendTo]="appendTo"
  [disabled]="disabled"
  (onShow)="onDropdownShow()"
  (onFilter)="onDropdownFilter($event)">
  <ng-template
    #itemTemplate
    let-company="item">
    @if (toCompany(company); as company) {
      <div class="flex align-items-center gap-2">
        <div>
          <span [innerHTML]="highlightMatchText(company.name) | safeHtml"></span>
        </div>
        @if (company.deleted) {
          <div class="font-medium text-red-500">(Удалена)</div>
        }
      </div>
    }
  </ng-template>
</crm-single-select>
